"use strict";
var body = document.querySelector("body");
function showMessage(message, type) {
    var div = document.createElement("div");
    div.setAttribute("data-qa", "notification");
    div.classList.add("".concat(type));
    div.textContent = message;
    body.appendChild(div);
}
var firstPromise = new Promise(function(resolve, reject) {
    var id = setTimeout(function() {
        return reject(new Error("First promise was rejected"));
    }, 3000);
    var firstPromiseHandler = function(e) {
        if (e.button === 0) {
            clearTimeout(id);
            resolve("First promise was resolved");
            document.removeEventListener("mousedown", firstPromiseHandler);
        }
    };
    document.addEventListener("mousedown", firstPromiseHandler);
});
var secondPromise = new Promise(function(resolve, reject) {
    var leftCheck = false;
    var rightCheck = false;
    var secondPromiseHandler = function(e) {
        if (e.button === 0) leftCheck = true;
        if (e.button === 2) rightCheck = true;
        if (leftCheck || rightCheck) {
            resolve("Second promise was resolved");
            document.removeEventListener("mousedown", secondPromiseHandler);
        }
    };
    document.addEventListener("mousedown", secondPromiseHandler);
});
var thirdPromise = new Promise(function(resolve, reject) {
    var leftCheck = false;
    var rightCheck = false;
    var thirdPromiseHandler = function(e) {
        if (e.button === 0) leftCheck = true;
        if (e.button === 2) rightCheck = true;
        if (leftCheck && rightCheck) {
            resolve("Third promise was resolved");
            document.removeEventListener("mousedown", thirdPromiseHandler);
        }
    };
    document.addEventListener("mousedown", thirdPromiseHandler);
});
firstPromise.then(function(message) {
    showMessage(message, "success");
}).catch(function(message) {
    var errorMessage = message.message;
    showMessage(errorMessage, "error");
});
secondPromise.then(function(message) {
    showMessage(message, "success");
});
thirdPromise.then(function(message) {
    showMessage(message, "success");
});

//# sourceMappingURL=index.7e55a3f2.js.map
